// extracted by mini-css-extract-plugin
module.exports = {"delimiter":"ItemDelimiter_delimiter__1ySj4"};